import { type QliroOrderItem } from 'ecosystem'
import { roundNumber, sumArrayOfNumbers } from 'shared-utils'
import { type QliroCheckoutOrderData } from './types'

/** @see https://developers.qliro.com/docs/qliro-checkout/checkout-features/update-order */
export const lockQliroCheckout = () => {
  window.q1?.lock()
}

export const unlockQliroCheckout = () => {
  window.q1?.unlock()
}

/**
 * Sync the Qliro frontend after a server-side order update.
 * Verifies the updated total matches the expected total before unlocking.
 * @see https://developers.qliro.com/docs/qliro-checkout/frontend-features/listeners
 */
export const syncQliroCheckout = (expectedTotal: number, onSynced?: () => void) => {
  window.q1?.onOrderUpdated((order: QliroCheckoutOrderData) => {
    if (order.totalPrice === expectedTotal) {
      unlockQliroCheckout()
      onSynced?.()
    }
  })
}

export const getQliroOrderLinesTotal = (orderLines: QliroOrderItem[]) =>
  roundNumber(sumArrayOfNumbers(orderLines.map((line) => line.PricePerItemIncVat * line.Quantity)))
